export default "__VITE_ASSET__daa8a81b__"